import type { ExecutionEnvironmentDescriptor } from "@heydex/contracts";
import * as Effect from "effect/Effect";

import { runPrimaryHttp } from "../../lib/runtime";
import { PrimaryEnvironmentHttpClient } from "./httpClient";

let descriptor: Promise<ExecutionEnvironmentDescriptor> | null = null;

/** The runtime's descriptor, read once per page; a failed read is tried again on the next call. */
export function resolveInitialPrimaryEnvironmentDescriptor(): Promise<ExecutionEnvironmentDescriptor> {
  descriptor ??= runPrimaryHttp(
    PrimaryEnvironmentHttpClient.pipe(Effect.flatMap((client) => client.metadata.descriptor())),
  ).catch((error: unknown) => {
    descriptor = null;
    throw error;
  });
  return descriptor;
}
